import React, { useState, useEffect } from "react";
/** Helper */
import FormContent from "../../components/organization/orgEventFormSchema.jsx";

import {
  isError,
  getErrorMsg,
  validateForm,
} from "../../helper/FormHelper.jsx";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import { postDataRequest, getDataRequest } from "../../helper/AxiosHelper";
import { useNavigate, useParams } from "react-router-dom";
/** Component */
import {
  Box,
  Grid,
  Container,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Paper,
  Button,
} from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import CommonBreadcrumb from "../../components/common/CommonBreadcrumb";
import FormikAutoCompleteMultiSelector from "../../components/common/CommonForm/FormikAutoCompleteMultiSelector";
/** Content */

/** API */

export default function Component() {
  // URL
  let { orgId } = useParams();
  // navigate
  const navigate = useNavigate();
  const [orgData, setOrgData] = useState({});

  useEffect(() => {
    getDataRequest(`organization/show/${orgId}`, (isSuccess, data) => {
      if (!isSuccess) {
        console.log("Data not found with id - " + orgId);
      }
      let { record } = data;

      setOrgData(record);
    });
  }, []);
  // Formik
  const formik = useFormik(FormContent.FormikInstance);
  //create function
  const handleCreateOrgEvent = async (e) => {
    if (await validateForm(formik)) return;
    let formData = JSON.parse(JSON.stringify(formik.values));
    formData["organization_id"] = orgId;

    postDataRequest("event/create", formData, (isSuccess, data) => {
      if (!isSuccess) {
        return toast.error("新增失敗");
      }

      toast.success("新增成功");
      setTimeout(() => navigate(`/organization/${orgId}/events`), 1500);

      return;
    });
  };
  return (
    <Container maxWidth={"lg"}>
      <CommonBreadcrumb
        dbData={{ organization_id: orgId, organization_name: orgData?.name_zh }}
      />
      <Box component="form" sx={{ mt: 3 }}>
        <Paper sx={{ px: 3, py: 5 }} elevation={3}>
          <Grid container rowSpacing={3} columnSpacing={2}>
            {FormContent.FormControl.map((item, index) => {
              let gridStyle = "size" in item ? item.size : { xs: 12 };
              let formControlProps = item.props;
              if (item.variant === "selector") {
                return (
                  <Grid item key={`form-section-${index}`} {...gridStyle}>
                    <FormControl
                      fullWidth
                      error={isError(formik, formControlProps.id)}
                    >
                      <InputLabel>{formControlProps.label}</InputLabel>
                      <Select
                        {...formControlProps}
                        fullWidth
                        value={formik.values[formControlProps.id]}
                        onChange={(event) => {
                          formik.setFieldValue(
                            formControlProps.id,
                            event.target.value
                          );
                        }}
                        onBlur={(event) => {
                          formik.touched[formControlProps.id] = true;
                        }}
                      >
                        <MenuItem value={""} disabled sx={{ ml: 2 }}>
                          {item.placeHolder}
                        </MenuItem>
                        {item.options.map((_area, index) => (
                          <MenuItem key={`area-${index}`} value={_area.value}>
                            {_area.label}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText>
                        {getErrorMsg(formik, formControlProps.id)}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                );
              }
              if (item.variant === "dateTime") {
                const dateError = isError(formik, formControlProps.id);
                return (
                  <Grid item key={`form-section-${index}`} {...gridStyle}>
                    <FormControl
                      error={isError(formik, formControlProps.id)}
                      fullWidth
                    >
                      <DateTimePicker
                        {...formControlProps}
                        onClose={() =>
                          (formik.touched[formControlProps.id] = true)
                        }
                        onChange={(newValue) =>
                          formik.setFieldValue(formControlProps.id, newValue)
                        }
                        onError={(reason, value) => {
                          alert("error");
                        }}
                        value={formik.values[formControlProps.id]}
                        renderInput={(formControlProps) => (
                          <TextField {...formControlProps} error={dateError} />
                        )}
                      />
                      <FormHelperText>
                        {getErrorMsg(formik, formControlProps.id)}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                );
              }
              if (item.variant === "multiSelector") {
                return (
                  <Grid item key={`form-section-${index}`} {...gridStyle}>
                    <FormikAutoCompleteMultiSelector
                      formik={formik}
                      elementContent={item}
                    />
                  </Grid>
                );
              }

              return (
                <Grid item key={`form-section-${index}`} {...gridStyle}>
                  <TextField
                    {...formControlProps}
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    error={isError(formik, formControlProps.id)}
                    helperText={getErrorMsg(formik, formControlProps.id)}
                    fullWidth
                  />
                </Grid>
              );
            })}
            <Grid item xs={12}>
              <Button
                variant="contained"
                sx={{ maxWidth: { xs: "auto", md: "150px" } }}
                onClick={handleCreateOrgEvent}
                disabled={!formik.isValid}
              >
                新增
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Box>
    </Container>
  );
}
